// DATE PARSING ------------------------------

// Parse a date value into a Date in LOCAL time, or null if unparseable.
//
// new Date("2026-09-12") is specified to parse as UTC midnight, so rendering it
// with toLocaleDateString() anywhere west of Greenwich shows the PREVIOUS day.
// Six of the seven formatDate implementations in this file did exactly that, so
// job, invoice and expense dates all displayed a day early in Orlando. Date-only
// ISO strings are therefore built from their components. Everything else - ISO
// datetimes, "09/12/2026", epoch numbers, Date objects - already carries a
// timezone or is unambiguous, and passes through.
export function parseLocalDate(value) {
  // Any falsy value means "no date" here, including 0. Nothing in this app dates
  // from the epoch, and sentDate is defaulted to 0 in several sorts, so treating
  // 0 as a real date would render 12/31/1969 where callers expect "N/A".
  if (!value) return null;
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === "string") {
    const isoDateOnly = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoDateOnly) {
      const year = Number(isoDateOnly[1]);
      const month = Number(isoDateOnly[2]) - 1;
      const day = Number(isoDateOnly[3]);
      const built = new Date(year, month, day);
      // Reject impossible dates rather than letting them roll over:
      // new Date(2026, 1, 31) would silently become 3 March.
      if (built.getMonth() !== month || built.getDate() !== day) return null;
      return built;
    }
  }
  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? null : parsed;
}
